export { default } from '@/components/pages/MyInvestments/MyInvestments'

export async function getServerSideProps() {
  return {
    props: {
      domain: 'fansinvest.angel.com',
      seo: {
        title: 'Your Investments',
      },
    },
  }
}
